import { Helmet } from "react-helmet";
import HeaderHome from "../../components/headerHome/HeaderHome";
import { MiFooter } from "../../components/footer/MiFooter";
import { useState } from "react";
import axios from "axios";

export const Soporte = () => {
    const [nombre, setNombre] = useState("");
    const [apellidos, setApellidos] = useState("");
    const [email, setEmail] = useState("");
    const [mensaje, setMensaje] = useState("");
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");

    const enviarDatos = async () => {
        const data = {
            nombre: nombre,
            apellidos: apellidos,
            email: email,
            mensaje: mensaje
        }

        const response = await axios({
                method: 'POST',
                url: window.ipdirection + 'api/enviar-soporte/',
                data: data,
            })

        if(response.status === 200) {
            setMessage("Mensaje enviado correctamente");
        } else {
            setError("Error al enviar el mensaje");
        }
        
        setNombre("");
        setApellidos("");
        setEmail("");
        setMensaje("");
    }

    return (
        <>
            <Helmet>
                <title>Soporte | Cuidatia</title>
                <meta name="description" content="Bienvenido al soporte de Cuidatia. Aquí puedes encontrar respuestas a tus preguntas." />
                <link rel="canonical" href="https://www.cuidatia.org/soporte" />
            </Helmet>

            <HeaderHome />

            <div className="container py-5 min-vh-100 d-flex flex-column">
                <div className="text-center mb-5">
                    <h1 className="display-5 fw-bold">Soporte</h1>
                    <p className="lead text-muted">
                        ¿Tienes alguna pregunta o necesitas ayuda? Completa el siguiente formulario y nos pondremos en contacto contigo lo antes posible.
                    </p>
                </div>

                <div className="row justify-content-center">
                    <div className="col-lg-8">
                        <div className="card shadow-lg border-0 p-4">
                            <h5 className="mb-4">Formulario de contacto</h5>
                            <div>
                                <div className="row mb-3">
                                    <div className="col-md-6">
                                        <label htmlFor="name" className="form-label">Nombre</label>
                                        <input type="text" className="form-control text-dark" id="name" placeholder="Tu nombre" 
                                            required
                                            value={nombre}
                                            onChange={(e) => setNombre(e.target.value)}
                                        />
                                    </div>
                                    <div className="col-md-6">
                                        <label htmlFor="lastname" className="form-label">Apellidos</label>
                                        <input type="text" className="form-control text-dark" id="lastname" placeholder="Tus apellidos" 
                                            value={apellidos}
                                            onChange={(e) => setApellidos(e.target.value)}
                                        />
                                    </div>
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="email" className="form-label">Correo electrónico</label>
                                    <input type="email" className="form-control text-dark" id="email" placeholder="Tu email" 
                                        required 
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                    />
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="message" className="form-label">Mensaje</label>
                                    <textarea className="form-control text-dark" id="message" rows="4" placeholder="Escribe tu mensaje aquí..." 
                                        required 
                                        value={mensaje}
                                        onChange={(e) => setMensaje(e.target.value)}
                                    />
                                </div>

                                <div className="d-grid">
                                    <button className="btn btn-primary"
                                        onClick={enviarDatos}
                                    >
                                        Enviar mensaje
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {message ?
                    <div className="alert alert-success mt-4" role="alert">
                        {message}
                    </div>
                : error &&
                    <div className="alert alert-danger mt-4" role="alert">
                        {error}
                    </div>
                }
            </div>

            <MiFooter />
        </>
    );
}